var map = {
	"./ac.svg": 88212,
	"./ad.svg": 75006,
	"./ae.svg": 54508,
	"./af.svg": 40389,
	"./afar.svg": 81816,
	"./ag.svg": 75318,
	"./ai.svg": 76648,
	"./al.svg": 70754,
	"./am.svg": 92545,
	"./ao.svg": 72273,
	"./aq.svg": 76551,
	"./ar.svg": 39723,
	"./as.svg": 7874,
	"./at.svg": 4661,
	"./au-aboriginal.svg": 66266,
	"./au-act.svg": 11457,
	"./au-nsw.svg": 1973,
	"./au-nt.svg": 93477,
	"./au-qld.svg": 73989,
	"./au-sa.svg": 4540,
	"./au-tas.svg": 20862,
	"./au-vic.svg": 81630,
	"./au-wa.svg": 5953,
	"./au.svg": 62703,
	"./aw.svg": 79205,
	"./ax.svg": 79444,
	"./az.svg": 17112,
	"./ba.svg": 87217,
	"./bb.svg": 83939,
	"./bd.svg": 37494,
	"./be.svg": 45859,
	"./bf.svg": 65679,
	"./bg.svg": 41190,
	"./bh.svg": 26480,
	"./bi.svg": 10622,
	"./bj.svg": 69075,
	"./bl.svg": 82138,
	"./bm.svg": 32602,
	"./bn.svg": 77479,
	"./bo.svg": 88766,
	"./bq-bo.svg": 22511,
	"./bq-sa.svg": 56692,
	"./bq-se.svg": 76040,
	"./bq.svg": 22511,
	"./br.svg": 10068,
	"./bs.svg": 26884,
	"./bt.svg": 54498,
	"./bv.svg": 50679,
	"./bw.svg": 78998,
	"./by.svg": 55271,
	"./bz.svg": 47387,
	"./ca-bc.svg": 56475,
	"./ca.svg": 57839,
	"./cc.svg": 58617,
	"./cd.svg": 15360,
	"./cf.svg": 64645,
	"./cg.svg": 93235,
	"./ch-gr.svg": 18673,
	"./ch.svg": 96077,
	"./ci.svg": 41044,
	"./ck.svg": 47788,
	"./cl.svg": 20616,
	"./cm.svg": 37568,
	"./cn-xj.svg": 58572,
	"./cn.svg": 77706,
	"./co.svg": 99890,
	"./cp.svg": 64556,
	"./cq.svg": 55951,
	"./cr.svg": 84160,
	"./cu.svg": 33234,
	"./cv.svg": 24674,
	"./cw.svg": 20476,
	"./cx.svg": 60185,
	"./cy.svg": 98261,
	"./cz.svg": 50639,
	"./de.svg": 42346,
	"./dg.svg": 63570,
	"./dj.svg": 60390,
	"./dk.svg": 49921,
	"./dm.svg": 83822,
	"./do.svg": 64764,
	"./dz.svg": 99410,
	"./ea.svg": 83652,
	"./earth.svg": 68196,
	"./east_african_federation.svg": 95287,
	"./easter_island.svg": 58873,
	"./ec-w.svg": 5112,
	"./ec.svg": 62978,
	"./ee.svg": 95344,
	"./eg.svg": 41752,
	"./eh.svg": 42046,
	"./er.svg": 64566,
	"./es-ar.svg": 9719,
	"./es-ce.svg": 83652,
	"./es-cn.svg": 13985,
	"./es-ct.svg": 47831,
	"./es-ga.svg": 28354,
	"./es-ib.svg": 89106,
	"./es-ml.svg": 84798,
	"./es-pv.svg": 2027,
	"./es-variant.svg": 32024,
	"./es.svg": 43610,
	"./et-or.svg": 33147,
	"./et-ti.svg": 58799,
	"./et.svg": 65225,
	"./eu.svg": 46454,
	"./european_union.svg": 46454,
	"./ewe.svg": 90285,
	"./fi.svg": 89401,
	"./fictional/klingon.svg": 32941,
	"./fj.svg": 58355,
	"./fk.svg": 5902,
	"./fm.svg": 67039,
	"./fo.svg": 87271,
	"./fr-20r.svg": 14526,
	"./fr-bre.svg": 88114,
	"./fr-cp.svg": 64556,
	"./fr.svg": 22589,
	"./fx.svg": 22589,
	"./ga.svg": 15776,
	"./gb-con.svg": 37025,
	"./gb-eng.svg": 13380,
	"./gb-nir.svg": 24250,
	"./gb-ork.svg": 2912,
	"./gb-sct.svg": 23453,
	"./gb-wls.svg": 95543,
	"./gb.svg": 4194,
	"./gd.svg": 21387,
	"./ge-ab.svg": 14607,
	"./ge.svg": 13858,
	"./gf.svg": 75106,
	"./gg.svg": 86689,
	"./gh.svg": 29966,
	"./gi.svg": 5976,
	"./gl.svg": 49888,
	"./gm.svg": 89219,
	"./gn.svg": 33366,
	"./gp.svg": 29408,
	"./gq.svg": 36211,
	"./gr.svg": 95151,
	"./gs.svg": 82289,
	"./gt.svg": 29612,
	"./gu.svg": 28417,
	"./guarani.svg": 78281,
	"./gw.svg": 52917,
	"./gy.svg": 83881,
	"./hausa.svg": 81543,
	"./hk.svg": 32037,
	"./hm.svg": 62703,
	"./hmong.svg": 71553,
	"./hn.svg": 70608,
	"./hr.svg": 24958,
	"./ht.svg": 99911,
	"./hu.svg": 41107,
	"./ic.svg": 13985,
	"./id-jb.svg": 59553,
	"./id-jt.svg": 1690,
	"./id.svg": 10135,
	"./ie.svg": 59140,
	"./il.svg": 30899,
	"./im.svg": 48335,
	"./in-as.svg": 331,
	"./in-gj.svg": 13444,
	"./in-ka.svg": 17210,
	"./in-or.svg": 48516,
	"./in-tg.svg": 89853,
	"./in-tn.svg": 18061,
	"./in.svg": 86142,
	"./io.svg": 63570,
	"./iq.svg": 91770,
	"./ir.svg": 51315,
	"./is.svg": 38086,
	"./it-23.svg": 50591,
	"./it-82.svg": 91499,
	"./it-88.svg": 20297,
	"./it.svg": 87123,
	"./je.svg": 81229,
	"./jm.svg": 79740,
	"./jo.svg": 5578,
	"./jp.svg": 58352,
	"./kanuri.svg": 33999,
	"./ke.svg": 30012,
	"./kg.svg": 91630,
	"./kh.svg": 46009,
	"./ki.svg": 97691,
	"./kikuyu.svg": 35612,
	"./km.svg": 21675,
	"./kn.svg": 51982,
	"./kongo.svg": 5647,
	"./kp.svg": 967,
	"./kr.svg": 52258,
	"./kurdistan.svg": 96230,
	"./kw.svg": 67831,
	"./ky.svg": 65815,
	"./kz.svg": 44111,
	"./la.svg": 63660,
	"./language/aa.svg": 81816,
	"./language/ab.svg": 14607,
	"./language/af.svg": 44779,
	"./language/ak.svg": 29966,
	"./language/am.svg": 65225,
	"./language/an.svg": 9719,
	"./language/ar.svg": 65867,
	"./language/as.svg": 331,
	"./language/av.svg": 43931,
	"./language/ay.svg": 52437,
	"./language/az.svg": 17112,
	"./language/ba.svg": 60403,
	"./language/be.svg": 55271,
	"./language/bg.svg": 41190,
	"./language/bi.svg": 69283,
	"./language/bm.svg": 25329,
	"./language/bn.svg": 37494,
	"./language/bo.svg": 28174,
	"./language/br.svg": 88114,
	"./language/bs.svg": 87217,
	"./language/ca.svg": 47831,
	"./language/ce.svg": 77944,
	"./language/ceb.svg": 84322,
	"./language/ch.svg": 28417,
	"./language/chm.svg": 23971,
	"./language/ckb.svg": 96230,
	"./language/co.svg": 14526,
	"./language/cs.svg": 50639,
	"./language/cv.svg": 33651,
	"./language/cy.svg": 95543,
	"./language/da.svg": 49921,
	"./language/de.svg": 42346,
	"./language/dv.svg": 85016,
	"./language/dz.svg": 54498,
	"./language/ee.svg": 90285,
	"./language/el.svg": 95151,
	"./language/en-au.svg": 8642,
	"./language/en-ca.svg": 94126,
	"./language/en-in.svg": 50963,
	"./language/en-ng.svg": 29370,
	"./language/en-nz.svg": 60179,
	"./language/en-us.svg": 33991,
	"./language/en-za.svg": 96138,
	"./language/en.svg": 4194,
	"./language/eo.svg": 63702,
	"./language/es.svg": 43610,
	"./language/et.svg": 95344,
	"./language/eu.svg": 2027,
	"./language/fa.svg": 51315,
	"./language/fi.svg": 89401,
	"./language/fj.svg": 58355,
	"./language/fo.svg": 87271,
	"./language/fr.svg": 22589,
	"./language/fy.svg": 72451,
	"./language/ga.svg": 59140,
	"./language/gd.svg": 23453,
	"./language/gl.svg": 28354,
	"./language/gn.svg": 78281,
	"./language/gu.svg": 13444,
	"./language/gv.svg": 48335,
	"./language/ha.svg": 81543,
	"./language/haw.svg": 60322,
	"./language/he.svg": 30899,
	"./language/hi.svg": 86142,
	"./language/hmn.svg": 71553,
	"./language/ho.svg": 35760,
	"./language/hr.svg": 24958,
	"./language/ht.svg": 99911,
	"./language/hu.svg": 41107,
	"./language/hy.svg": 92545,
	"./language/ia.svg": 35199,
	"./language/id.svg": 10135,
	"./language/ie.svg": 22078,
	"./language/ig.svg": 26312,
	"./language/ilo.svg": 84322,
	"./language/interslavic.svg": 44025,
	"./language/io.svg": 66550,
	"./language/is.svg": 38086,
	"./language/it.svg": 87123,
	"./language/ja.svg": 58352,
	"./language/jv.svg": 1690,
	"./language/ka.svg": 13858,
	"./language/kg.svg": 5647,
	"./language/ki.svg": 35612,
	"./language/kk.svg": 44111,
	"./language/kl.svg": 49888,
	"./language/km.svg": 46009,
	"./language/kn.svg": 17210,
	"./language/ko.svg": 52258,
	"./language/kr.svg": 33999,
	"./language/kri.svg": 80025,
	"./language/ks.svg": 66498,
	"./language/ku.svg": 96230,
	"./language/kv.svg": 75089,
	"./language/kw.svg": 37025,
	"./language/ky.svg": 91630,
	"./language/la.svg": 16567,
	"./language/lb.svg": 21832,
	"./language/lg.svg": 1213,
	"./language/ln.svg": 5647,
	"./language/lo.svg": 63660,
	"./language/lt.svg": 68927,
	"./language/lu.svg": 15360,
	"./language/lus.svg": 14459,
	"./language/lv.svg": 78468,
	"./language/mg.svg": 95863,
	"./language/mh.svg": 16260,
	"./language/mi.svg": 69186,
	"./language/mk.svg": 35202,
	"./language/ml.svg": 22131,
	"./language/mn.svg": 29143,
	"./language/mni.svg": 56986,
	"./language/mr.svg": 53793,
	"./language/mrj.svg": 23971,
	"./language/ms.svg": 21355,
	"./language/mt.svg": 61832,
	"./language/my.svg": 89449,
	"./language/na.svg": 11782,
	"./language/nb.svg": 50679,
	"./language/nd.svg": 99280,
	"./language/ne.svg": 84712,
	"./language/nl.svg": 30358,
	"./language/nn.svg": 50679,
	"./language/no.svg": 50679,
	"./language/non.svg": 31278,
	"./language/nr.svg": 44779,
	"./language/ny.svg": 75529,
	"./language/oc.svg": 15397,
	"./language/om.svg": 33147,
	"./language/or.svg": 48516,
	"./language/os.svg": 69360,
	"./language/oto.svg": 22026,
	"./language/pa.svg": 86142,
	"./language/pap.svg": 79205,
	"./language/pl.svg": 17340,
	"./language/ps.svg": 40389,
	"./language/pt-br.svg": 10068,
	"./language/pt.svg": 70384,
	"./language/qu.svg": 63062,
	"./language/rm.svg": 18673,
	"./language/rn.svg": 10622,
	"./language/ro.svg": 43978,
	"./language/ru.svg": 23971,
	"./language/rw.svg": 17829,
	"./language/sc.svg": 20297,
	"./language/sd.svg": 15854,
	"./language/se.svg": 87847,
	"./language/sg.svg": 64645,
	"./language/si.svg": 92392,
	"./language/sk.svg": 30526,
	"./language/sl.svg": 49569,
	"./language/sm.svg": 97854,
	"./language/sn.svg": 99280,
	"./language/so.svg": 82182,
	"./language/sq.svg": 70754,
	"./language/sr.svg": 42499,
	"./language/ss.svg": 67958,
	"./language/st.svg": 4842,
	"./language/su.svg": 59553,
	"./language/sv.svg": 52187,
	"./language/sw.svg": 30012,
	"./language/ta.svg": 18061,
	"./language/te.svg": 89853,
	"./language/tg.svg": 59597,
	"./language/th.svg": 69552,
	"./language/ti.svg": 58799,
	"./language/tk.svg": 46485,
	"./language/tl.svg": 84322,
	"./language/tn.svg": 78998,
	"./language/to.svg": 66542,
	"./language/tr.svg": 70381,
	"./language/tt.svg": 27538,
	"./language/ty.svg": 59851,
	"./language/udm.svg": 65301,
	"./language/ug.svg": 58572,
	"./language/uk.svg": 58871,
	"./language/ur.svg": 12109,
	"./language/uz.svg": 97776,
	"./language/vi.svg": 59836,
	"./language/vo.svg": 12824,
	"./language/xh.svg": 44779,
	"./language/xx.svg": 945,
	"./language/yi.svg": 32058,
	"./language/yo.svg": 46235,
	"./language/yua.svg": 6807,
	"./language/zh.svg": 77706,
	"./language/zu.svg": 44779,
	"./lb.svg": 57365,
	"./lc.svg": 70144,
	"./li.svg": 95705,
	"./lk.svg": 92392,
	"./lr.svg": 64217,
	"./ls.svg": 4842,
	"./lt.svg": 68927,
	"./lu.svg": 21832,
	"./lv.svg": 78468,
	"./ly.svg": 2934,
	"./ma.svg": 75887,
	"./malayali.svg": 22131,
	"./manipur.svg": 56986,
	"./maori.svg": 69186,
	"./mc.svg": 55050,
	"./md.svg": 18065,
	"./me.svg": 13168,
	"./mf.svg": 29062,
	"./mg.svg": 95863,
	"./mh.svg": 16260,
	"./mizoram.svg": 14459,
	"./mk.svg": 35202,
	"./ml.svg": 25329,
	"./mm.svg": 89449,
	"./mn.svg": 29143,
	"./mo.svg": 56176,
	"./mp.svg": 98426,
	"./mq.svg": 76836,
	"./mr.svg": 9904,
	"./ms.svg": 99949,
	"./mt.svg": 61832,
	"./mu.svg": 87117,
	"./mv.svg": 85016,
	"./mw.svg": 75529,
	"./mx.svg": 6807,
	"./my.svg": 21355,
	"./mz.svg": 86093,
	"./na.svg": 88551,
	"./nato.svg": 3491,
	"./nc.svg": 15118,
	"./ne.svg": 24411,
	"./nf.svg": 52511,
	"./ng.svg": 26312,
	"./ni.svg": 65630,
	"./nl-fr.svg": 72451,
	"./nl.svg": 30358,
	"./no.svg": 50679,
	"./northern_cyprus.svg": 55957,
	"./np.svg": 84712,
	"./nr.svg": 11782,
	"./nu.svg": 23702,
	"./nz.svg": 51725,
	"./occitania.svg": 15397,
	"./olympics.svg": 65727,
	"./om.svg": 77165,
	"./otomi.svg": 22026,
	"./pa.svg": 23587,
	"./pe.svg": 15083,
	"./pf.svg": 59851,
	"./pg.svg": 35760,
	"./ph.svg": 84322,
	"./pk-jk.svg": 66498,
	"./pk-sd.svg": 15854,
	"./pk.svg": 12109,
	"./pl.svg": 17340,
	"./pm.svg": 42703,
	"./pn.svg": 18026,
	"./pr.svg": 78656,
	"./ps.svg": 22924,
	"./pt-20.svg": 80452,
	"./pt-30.svg": 35754,
	"./pt.svg": 70384,
	"./pw.svg": 90294,
	"./py.svg": 93075,
	"./qa.svg": 35970,
	"./quechua.svg": 63062,
	"./re.svg": 3950,
	"./ro.svg": 43978,
	"./rs.svg": 42499,
	"./ru-ba.svg": 60403,
	"./ru-ce.svg": 77944,
	"./ru-cu.svg": 33651,
	"./ru-da.svg": 43931,
	"./ru-ko.svg": 75089,
	"./ru-ta.svg": 27538,
	"./ru-ud.svg": 65301,
	"./ru.svg": 23971,
	"./rw.svg": 17829,
	"./sa.svg": 97839,
	"./sami.svg": 87847,
	"./sb.svg": 6374,
	"./sc.svg": 79556,
	"./sd.svg": 71299,
	"./se.svg": 52187,
	"./sg.svg": 72311,
	"./sh-ac.svg": 88212,
	"./sh-hl.svg": 82775,
	"./sh-ta.svg": 90688,
	"./sh.svg": 82775,
	"./si.svg": 49569,
	"./sj.svg": 50679,
	"./sk.svg": 30526,
	"./sl.svg": 80025,
	"./sm.svg": 72795,
	"./sn.svg": 11617,
	"./so.svg": 82182,
	"./somaliland.svg": 20797,
	"./south_ossetia.svg": 69360,
	"./soviet_union.svg": 1682,
	"./sr.svg": 37462,
	"./ss.svg": 66784,
	"./st.svg": 9853,
	"./su.svg": 1682,
	"./sv.svg": 49675,
	"./sx.svg": 43363,
	"./sy.svg": 61523,
	"./sz.svg": 67958,
	"./ta.svg": 90688,
	"./tc.svg": 28251,
	"./td.svg": 68102,
	"./tf.svg": 75239,
	"./tg.svg": 55523,
	"./th.svg": 69552,
	"./tibet.svg": 28174,
	"./tj.svg": 59597,
	"./tk.svg": 97860,
	"./tl.svg": 69487,
	"./tm.svg": 46485,
	"./tn.svg": 99249,
	"./to.svg": 66542,
	"./torres_strait_islands.svg": 97063,
	"./tr.svg": 70381,
	"./transnistria.svg": 31003,
	"./tt.svg": 73072,
	"./tv.svg": 18011,
	"./tw.svg": 40598,
	"./tz.svg": 58764,
	"./ua.svg": 58871,
	"./ug.svg": 1213,
	"./uk.svg": 4194,
	"./um.svg": 15619,
	"./un.svg": 63008,
	"./united_nations.svg": 63008,
	"./us-ak.svg": 75438,
	"./us-al.svg": 33014,
	"./us-ar.svg": 94534,
	"./us-az.svg": 76710,
	"./us-ca.svg": 3496,
	"./us-co.svg": 32818,
	"./us-dc.svg": 23431,
	"./us-fl.svg": 46524,
	"./us-ga.svg": 30135,
	"./us-hi.svg": 60322,
	"./us-in.svg": 92853,
	"./us-mo.svg": 87175,
	"./us-ms.svg": 66119,
	"./us-nc.svg": 90659,
	"./us-nm.svg": 28759,
	"./us-ri.svg": 94166,
	"./us-tn.svg": 37068,
	"./us-tx.svg": 51042,
	"./us.svg": 15619,
	"./uy.svg": 11691,
	"./uz.svg": 97776,
	"./va.svg": 72025,
	"./vc.svg": 51753,
	"./ve.svg": 76056,
	"./vg.svg": 28537,
	"./vi.svg": 17847,
	"./vn.svg": 59836,
	"./vu.svg": 69283,
	"./wf.svg": 96115,
	"./wiphala.svg": 52437,
	"./ws.svg": 97854,
	"./xk.svg": 51157,
	"./xx.svg": 945,
	"./ye.svg": 97373,
	"./yorubaland.svg": 46235,
	"./yt.svg": 99842,
	"./za.svg": 44779,
	"./zm.svg": 20272,
	"./zw.svg": 99280
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92378;